// Imports: Dependencies
import { combineReducers } from 'redux';

// Imports: Reducers
import UserConfigReducer from './UserConfigReducer';

// Redux: Root Reducer
const rootReducer = combineReducers({
   UserConfigReducer,
});

// Exports
export default rootReducer;